// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__cR7fc","visible":"style_visible__ibgvS","content":"style_content__6Mssu"};